import { Box, Typography } from '@mui/material'

export default function SettingsPage() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        个人设置
      </Typography>
      <Typography variant="body1" color="text.secondary">
        该页面尚未实现。
      </Typography>
    </Box>
  )
}
